import { usePropertyField } from './usePropertyField';
import { IApplicationRental } from '@apply/api/src/api/ApplyApi';

// ─── Address ──────────────────────────────────────────────────────────────────

export const usePropertyStreet1 = (propertyGuid: string) =>
    usePropertyField(propertyGuid, (p) => p.address?.street1, (p, v) => ({ ...p, address: { ...p.address, street1: v } }));

export const usePropertyStreet2 = (propertyGuid: string) =>
    usePropertyField(propertyGuid, (p) => p.address?.street2, (p, v) => ({ ...p, address: { ...p.address, street2: v } }));

export const usePropertyCity = (propertyGuid: string) =>
    usePropertyField(propertyGuid, (p) => p.address?.city, (p, v) => ({ ...p, address: { ...p.address, city: v } }));

export const usePropertyState = (propertyGuid: string) =>
    usePropertyField(propertyGuid, (p) => p.address?.state, (p, v) => ({ ...p, address: { ...p.address, state: v } }));

export const usePropertyZipCode = (propertyGuid: string) =>
    usePropertyField(propertyGuid, (p) => p.address?.zipCode, (p, v) => ({ ...p, address: { ...p.address, zipCode: v } }));

export const usePropertyCounty = (propertyGuid: string) =>
    usePropertyField(propertyGuid, (p) => p.address?.county, (p, v) => ({ ...p, address: { ...p.address, county: v } }));

// ─── Rental ───────────────────────────────────────────────────────────────────

export const usePropertyBuildRentTypeId = (propertyGuid: string) =>
    usePropertyField(
        propertyGuid,
        (p) => p.rental?.buildRentTypeId,
        (p, v) => ({ ...p, rental: { ...(p.rental ?? {}), buildRentTypeId: v } as IApplicationRental })
    );

export const usePropertyBuildWorkDescription = (propertyGuid: string) =>
    usePropertyField(
        propertyGuid,
        (p) => p.rental?.buildWorkDescriptionTypeId,
        (p, v) => ({ ...p, rental: { ...(p.rental ?? {}), buildWorkDescriptionTypeId: v } as IApplicationRental })
    );
